<template>
  <el-dialog :title="title" :visible="visible" width="640px" :before-close="handleClose">
    <div v-if="info.couponType == 0 || info.couponType == 1 || info.couponType == 3">
      <div class="coupon-info">
        <div class="coupon-price" v-if="info.couponType == 1">
          {{ info.couponValue }}折
          {{ getCouponValue(info.couponValue) }} off
        </div>
        <div class="coupon-price" v-else>￥{{ info.couponValue }}</div>
      </div>
      <div class="coupon-detail-item">
        <div><span>券类型 </span><span>Voucher Type</span></div>
        <div>
          <span> {{ info.couponType != null ? $optionsData.couponType[info.couponType].label : "" }}</span>
          <span>{{ info.couponType != null ? $optionsData.couponType[info.couponType].labelEn : "" }}</span>
        </div>

      </div>

      <div class="coupon-detail-item">
        <div><span>适用范围</span><span>Scope of application</span></div>
        <div v-if="info.writeOffLimitType == 0"><span>通用券</span> <span>General Coupons</span></div>
        <div v-else-if="info.writeOffLimitType == 1">
          <span>适用于{{ info.writeOffLimitCategoryName }}</span>
          <span>Available for {{ info.writeOffLimitCategoryNameEn }}</span>
        </div>
        <div v-else-if="info.writeOffLimitType == 2">
          <span>适用于{{ info.writeOffLimitChannelName }}</span>
          <span>Available for {{ info.writeOffLimitChannelNameEn }}</span>
        </div>
        <div v-else-if="info.writeOffLimitType == 3">
          <span>适用于指定商品 </span>
          <span>Available for Specified Commodity</span>
        </div>
        <div v-else-if="info.writeOffLimitType == 5">
          <span>适用于指定房型 </span>
          <span>Available for Specified Room Type</span>
        </div>
        <div v-else-if="info.writeOffLimitType == 4">
          <span>适用于订房 </span>
          <span>Available for Room Reservation</span>
        </div>
      </div>
      <div class="coupon-detail-item">
        <div>
          <span>使用条件</span>
          <span>Conditions of Use</span>
        </div>
        <div v-if="info.writeOffConditionSwitch == 1">
          <span>满{{ info.writeOffConditionPrice }}元可用</span>
          <span>payments over {{ info.writeOffConditionPrice }}</span>
        </div>
        <div v-else>
          <span>无门槛</span>
          <span>no threshold</span>
        </div>
      </div>
      <div class="coupon-detail-item" v-if="info.couponType == 1">
        <div><span>最高可抵 </span><span>The highest</span></div>
        <div>
          <span> ￥{{ info.discountMaxAmount}}</span>
          <span> ￥{{ info.discountMaxAmount}}</span>
        </div>
      </div>
      <div class="coupon-detail-item">
        <div>
          <span>有效期</span>
          <span>Expiry date</span>
        </div>
        <div>
          <span>{{ info.validStartTime }} 至 {{ info.validEndTime }}</span>
          <span>{{ info.validStartTime }} to {{ info.validEndTime }}</span>
        </div>
      </div>
      <div class="coupon-container">
        <!--        <div class="container-title">-->
        <!--          <span>使用须知</span>-->
        <!--          <span> Useful tips</span>-->
        <!--        </div>-->
        <!--        <div class="coupon-tips" v-for="item in tips" :key="item.chName">-->
        <!--          <div>{{ item.chName }}</div>-->
        <!--          <div class="en-name">{{ item.enName }}</div>-->
        <!--        </div>-->
        <div v-html="info.couponDesc"></div>
      </div>
    </div>
    <div class="coupon-tips" v-else-if="info.couponType == 2">
      <div class="coupon-qrcode">
        <QrCode :text="info.qrCode" class="coupon-qrcode-inner"></QrCode>
        <p>{{ info.qrCode }}</p>
        <p>向店员出示二维码进行礼品兑换</p>
        <p>Show the QR code to the clerk for gift exchange</p>
      </div>
      <div class="coupon-detail-item">
        <div>
          <span>券名称</span>
          <span>Coupon name</span>
        </div>
        <div>
          <span>{{ info.name }}</span>
          <span>{{ info.enName }}</span>
        </div>
      </div>
      <div class="coupon-detail-item">
        <div>
          <span>有效期</span>
          <span>Expiry date </span>
        </div>
        <div>
          <span>{{ info.validStartTime }} 至 {{ info.validEndTime }}</span>
          <span>{{ info.validStartTime }} to {{ info.validEndTime }}</span>
        </div>
      </div>
      <div class="coupon-detail-item">
        <div>
          <span>门市价</span>
          <span>Retail Price</span>
        </div>
        <div><span>￥{{ info.couponValue }}</span><span>￥{{ info.couponValue }}</span></div>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QrCode from "@/components/base/QrCode";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => {
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tips: [
        {
          chName: "1、通用券每单限用一张，可与品类专享、商家专享、单品装箱券叠加使用。",
          enName:
              "1, the general-purpose voucher each single limit uses one, may with the category exclusive enjoyment, the merchant exclusive enjoyment, the single article packing voucher superimposes uses.",
        },
        {
          chName: "2、品类专享、上架专享、单品专享券不可叠加使用，系统将自动挑选所持优惠券中优惠额度最高者使用。",
          enName:
              "2, category exclusive, shelf exclusive, single-product exclusive coupon can not be superimposed use, the system will automatically select the highest amount of coupons to use.",
        },
        {
          chName: "3、折扣券没有最高抵扣金额，具体优惠以使用时系统显示优惠金额为准。",
          enName:
              "3, the discount coupon does not have the highest deduction amount, the concrete preferential benefit uses when the system display preferential benefit amount to prevail.",
        },
      ],
    };
  },
  computed: {
    getCouponValue() {
      return function (couponValue) {
        if (typeof couponValue === "string")
          parseInt(couponValue)
        return `${100 - couponValue * 10}%`
      }

    }
  },
  components: {QrCode},
  created() {
  },
  async mounted() {
  },
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.coupon-container {
  margin-top: 20px;
  line-height: 1.2rem;
}

.coupon-info {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.coupon-detail-item {
  display: flex;
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  padding-left: 10%;

  div {
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    display: flex;
    display: -o-flex;
    display: -ms-flex;
    display: -moz-flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    align-items: flex-end;
    margin-right: 15px;

    span {
      line-height: 20px;
    }
  }

  div:last-child {
    align-items: flex-start;
  }

  div:first-child {
    width: 150px;
    text-align: right;

  }
}

.container-title {
  margin-bottom: 12px;
  margin-top: 12px;
}

.coupon-tips {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  padding-bottom: 36px;
  line-height: 1.2;
}

.coupon-tips .en-name {
  font-size: 12px;
}

// 礼金券
.coupon-qrcode {
  .coupon-qrcode-inner {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    color: #333;
    font-size: 14px;
  }

  p {
    text-align: center;
    line-height: 1.4;
  }
}
</style>
